/**
 * Reads overflow values from the body's *inline* style only.
 * CSS from <style> or stylesheets does not appear here (getPropertyValue returns '').
 */
export interface BodyInlineOverflow {
  overflow: string;
  overflowX: string;
  overflowY: string;
}

export function readBodyInlineOverflow(): BodyInlineOverflow {
  const s = document.body.style;
  return {
    overflow: s.getPropertyValue('overflow').trim(),
    overflowX: s.getPropertyValue('overflow-x').trim(),
    overflowY: s.getPropertyValue('overflow-y').trim()
  };
}

/**
 * Restores body inline overflow. Use removeProperty when a value was not set inline
 * so shorthand/longhand from a stylesheet is not left overridden by empty strings.
 */
export function writeBodyInlineOverflow(values: BodyInlineOverflow): void {
  const s = document.body.style;
  if (values.overflow) {
    s.setProperty('overflow', values.overflow);
  } else {
    s.removeProperty('overflow');
  }
  if (values.overflowX) {
    s.setProperty('overflow-x', values.overflowX);
  } else {
    s.removeProperty('overflow-x');
  }
  if (values.overflowY) {
    s.setProperty('overflow-y', values.overflowY);
  } else {
    s.removeProperty('overflow-y');
  }
}
